var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wisdom"},[_c('div',[_vm._v("BEEN DOWN LATELY?")]),_vm._v(" "),_c('div',{staticClass:"smaller"},[_vm._v("PLAY WITH YOUR MANDELBROT SET")]),_vm._v(" "),_c('div',{staticClass:"canvas-container"},[_c('canvas',{ref:"canvas"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d71e7b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mandelbrot.vue
// module id = null
// module chunks = 